import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';

export const jobsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getJobStatus: builder.query<GetJobResponse, { url: string }>({
      query: ({ url }) => ({
        url: url,
        method: 'GET',
      }),
      transformResponse: (result: { data: GetJobResponse; status: string }) => result.data,
      providesTags: () => [{ type: ServiceTypes.JOBS, id: 'GENERATE' }],
    }),
    generateProjectJob: builder.mutation<
      GenerateJobResponse,
      {
        projectId: number;
        data: { parameters: object; documentIds?: number[] };
      }
    >({
      query: ({ projectId, data }) => ({
        url: `/projects/${projectId}/generate`,
        method: 'POST',
        body: data,
      }),
    }),
    generateZipBuildJob: builder.mutation<GetJobResponse, { data: { assets_ids: number[] } }>({
      query: ({ data }) => ({
        url: `/zip-build-jobs`,
        method: 'POST',
        body: data,
      }),
    }),
    downloadJobZip: builder.mutation<Blob, { longpullId: number }>({
      query: ({ longpullId }) => ({
        url: `/zip-build-jobs/${longpullId}/download`,
        method: 'GET',
        headers: { 'Content-Type': 'application/zip' },
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: {
        skipCache: true,
      },
    }),
    getJobZipPresignedUrl: builder.mutation<any, { longpullId: number }>({
      query: ({ longpullId }) => ({
        url: `/zip-build-jobs/${longpullId}/download`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetJobStatusQuery,
  useGenerateZipBuildJobMutation,
  useGenerateProjectJobMutation,
  useDownloadJobZipMutation,
  useGetJobZipPresignedUrlMutation,
} = jobsService;
